import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Box, Button, Snackbar, IconButton } from "@material-ui/core";
import { gpColors } from "../../constants/colors";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import alen_jacob from "../../Images/alen-jacob.jpg";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import CircularProgress from "@material-ui/core/CircularProgress";
// import CryptoAES from "crypto-js/aes";
// import CryptoENC from "crypto-js/enc-utf8";
// import { useEffect } from "react";
import { setCookie, getCookie } from "../../Functions";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 100,
  },
  loginContainer: {
    height: "100vh",
    overflowX: "hidden",
    backgroundImage: `url(${alen_jacob})`,
    backgroundRepeat: "round",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
    backgroundColor: "rgba(54,64,75,0.5)",

    border: "none",
    borderRadius: "24px",
    padding: "1.5rem 1.5rem",
    // paddingBottom: "0px",
  },
  inputLabel: {
    color: "#fff",
    fontSize: "14px",
  },
  input: {
    display: "block",
    width: "100%",
    padding: "0.85rem 1rem",
    fontSize: "1rem",
    borderRadius: "0.25rem",
    border: "2px solid #c0c0c0",
    fontFamily: "inherit",
    backgroundColor: "#FFFFFF",
    marginBottom: "25px",
  },
  button: {
    padding: "0.85rem 1rem",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
  },
  icon: {
    textAlign: "center",
    color: "#87898B",
    transform: "scale(3.4)",
  },
  error: {
    paddingTop: "10px",
    textAlign: "center",
    color: "#FF1400",
  },
}));

export const ResetPassword = () => {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertColor: "",
    alertMessage: "",
  });

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!username) {
        setError("Please enter email ID");
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(username.trim())) {
        setError("Please enter a valid email address");
        return;
      }
      setLoader(true);

      const resp = await fetch(
        `${
          process.env.REACT_APP_API_ENDPOINT
        }/resetPassword?emailId=${username.trim()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const data = await resp.json();
      setLoader(false);

      if (data.result === "Success") {
        setAlert({
          alertStatus: true,
          alertColor: "green",
          alertMessage: data.resultMessage || "Email sent successfully!",
        });
      } else {
        setAlert({
          alertStatus: true,
          alertColor: "red",
          alertMessage:
            data.resultMessage ||
            "Unable to change password. Please try again.",
        });
      }

      setUsername("");
    } catch (error) {
      setLoader(false);
      setAlert({
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Network error. Please try again later.",
      });
      console.error("Error changing password:", error);
    }
  };

  return (
    <div className={classes.loginContainer}>
      <Container component={"main"} maxWidth="xs">
        <div component={"div"} className={classes.paper}>
          <form className={classes.form} onSubmit={(e) => handleSubmit(e)}>
            <div className={classes.icon}>
              <AccountCircleIcon fontSize="large" />
            </div>
            <div style={{ paddingTop: 40 }}>
              <Box className={classes.inputLabel}>Username</Box>
              <input
                className={classes.input}
                id="username"
                margin="normal"
                required
                placeholder="Username"
                value={username}
                type="text"
                onChange={(e) => setUsername(e.target.value)}
              />
              <Button type="submit" fullWidth className={classes.button}>
                {loader ? <CircularProgress size={25} /> : "Send Email"}
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: 10,
              }}
            >
              <span
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => navigate(routes.GPADMIN)}
              >
                Login?
              </span>
            </div>
            <div className={classes.error}>{error}</div>
          </form>
        </div>
        <Snackbar
          ContentProps={{
            style: { background: alert.alertColor },
          }}
          open={alert.alertStatus}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleAlertClose}
          message={alert.alertMessage || "Password changed successfully!"}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleAlertClose}
            >
              <Close fontSize="small" />
            </IconButton>
          }
        />
      </Container>
    </div>
  );
};
